import { render } from "./LanguageSwitch.vue?vue&type=template&id=bfe25ac0&ts=true"
import script from "./LanguageSwitch.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__